import React from 'react';

export const Logo = () => <img alt="Blaize" src="/images/logo.svg" height={45} />;
